import { PopupsNotificationsDialogComponent } from './../popups-notifications-dialog/popups-notifications-dialog.component';
import { ImageCacheService } from '@ildes/services/image-cache.service';
import { ChangeDetectorRef, Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { SessionStore } from '../../stores/session.store';
import { SessionService } from '../../services/session.service';
import { Router, NavigationStart } from '@angular/router';
import { UserSettingsDialogComponent } from '../../basic/user-settings-dialog/user-settings-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MediaMatcher } from '@angular/cdk/layout';
import { SelectUsersDialogComponent } from '@ildes/basic/select-users-dialog/select-users-dialog.component';
import { ApiManagerService } from '@ildes/services/api-manager.service';
import { ToastService } from '@ildes/services/toast.service';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import { NativeLayerService } from '@ildes/services/native-layer.service';
import { LogService } from 'src/app/services/log.service';
import { FingerprintService } from '../../services/fingerprint.service';
import { AutoUnsubscribeComponent } from '@ildes/abstracts/auto-unsubscribe.component';
import { RenewSessionDialogComponent } from '../renew-session-dialog/renew-session-dialog.component';
import { PRIVACY_VERSION } from '../policies/policies-version';
import { PrivacyPolicyConsentDialogComponent } from '../privacy-policy-consent-dialog/privacy-policy-consent-dialog.component';
const LIST_USER_ELEMENTS = ['token', 'user', 'assignedMaintenances', 'luminaries', 'dailyQuestionaries', 'unsync-expansions', 'unsync-modernizations'];

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent extends AutoUnsubscribeComponent implements OnInit, OnDestroy {

  showSessionInfo = false;
  user;
  mobileQuery: MediaQueryList;
  _mobileQueryListener;
  testPlugin;
  isUpdateAvailable;
  removesOnNext = false;
  @ViewChild("snav") snav: any;

  constructor(
    private fingerprint: FingerprintService,
    private router: Router,
    private sessionService: SessionService,
    private dialog: MatDialog,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private apiManager: ApiManagerService,
    private imageCache: ImageCacheService,
    private toast: ToastService,
    public nativeLayer: NativeLayerService,
    private log: LogService
  ) {
    super();
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart && this.mobileQuery.matches) {
        this.snav.close();
      }
    });
  }

  closeNav(){
    if (!this.mobileQuery.matches) {
      return;
    }

    this.snav.close();
  }

  ngOnInit(): void {
    const sessionStore = SessionStore.getInstance();
    if (this.nativeLayer.isNative) {
      this.calculateUpdateAvailable();
    }

    const sub = SessionStore.getInstance().get$().subscribe(async (data) => {
      if (!data?.user) {
        this.router.navigate(['signin']);

        return;
      }

      await this.imageCache.prune(true);

      this.showSessionInfo = this.sessionService.isExpiredSession();
      if (!this.showSessionInfo) {
        if (!data.user.privacyPolicyCheck || new Date(data.user.privacyPolicyVersion) < new Date(PRIVACY_VERSION)) {
            const dialog = this.dialog.open(PrivacyPolicyConsentDialogComponent, {
                disableClose: true,
                width: '600px',
                height: '600px',
                panelClass: 'responsive-dialog',
                data: {}
            });
    
            dialog.afterClosed().subscribe(() => {
               
            });
        }
      }
      this.user = data.user;
    });
    this.addSubscription(sub);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  gotoProfile() {
    this.router.navigate(['/app/user']);
  }

  gotoControlPanel() {

    this.router.navigate(['/app/control-panel']);
  }
  gotoMailbox() {
    this.router.navigate(['/app/mailbox']);
  }

  getCachedData () {
    const items = { ...localStorage };

    const filteredItems = Object.keys(items).filter(( item ) => LIST_USER_ELEMENTS.indexOf(item) < 0);

    return filteredItems;
  }
  async prune() {
    const items = this.getCachedData();
    const bytesArray = items.map((key) => localStorage.getItem(key).length);
    const bytes = bytesArray.reduce((sum, it) => sum + it, 0)

    if (!this.removesOnNext) {
      const data = await this.imageCache.prune();

      if (!data && bytes < 100) {
        this.toast.show(`No hay nada pendiente de eliminar.`, 'ok')
        return;
      }
      this.removesOnNext = true;
      this.toast.show(`Se borrarán ${data} imágenes y se liberarán ${bytes} bytes. Pulse otra vez para borrar`, 'warning')
    } else {
      const data = await this.imageCache.prune(true);
      items.map((key) => {
        localStorage.removeItem(key);
      });
      this.removesOnNext = false;
      this.toast.show(`Se han eliminado ${data} imágenes.`, 'ok')
      this.closeNav();
    }

  }
  async support() {
    const items = { ...localStorage };
    const cache = await this.imageCache.getStatus();
    const deviceInfo = await Device.getInfo();
    const data = {
      cache: JSON.stringify(cache),
      items: JSON.stringify(items),
      deviceInfo: JSON.stringify(deviceInfo),
    };

    this.log.enabled = true;
    this.apiManager.postIssueData({data}).subscribe(() => {

    }, () => {

    })
  }

  onClose() {
    this.removesOnNext = false;
  }

  async exit() {
    this.router.navigate(['signin']);
  }


  configureGroup() {

    const dialog = this.dialog.open(SelectUsersDialogComponent, {
      width: '600px',
      height: '600px',
      panelClass: 'responsive-dialog',
      data: { selected: [{...this.user}], disabled: [{...this.user}], roleId: ['TECHNICIAN', 'DRIVER'], belongsToMyProjects: true}
    });

    dialog.afterClosed().subscribe( (data) => {
      if (data.close) {
        return;
      }
      const selectedParticipants =  data.participants.filter(({ id }) => id !== this.user.id );

      this.apiManager.setCoworker(this.user.id, {
        coworkers: selectedParticipants.map(({id}) => id),
      }).subscribe((data: any) => {
       SessionStore.updateUserInfo({
          coworkers: selectedParticipants
        });
      });
    });

  }

  gotoBills() {
    this.router.navigate(['app/bills']);
  }


  openSettings() {
    const dialog = this.dialog.open(UserSettingsDialogComponent, {
      width: '600px',
      height: '600px',
      panelClass: 'responsive-dialog'
    });
  }


  async showPopupsNotification() {
    // build: 20
    // version: 3.2.0
    const dialog = this.dialog.open(PopupsNotificationsDialogComponent, {

    });
  }

  async calculateUpdateAvailable() {
    this.apiManager.getVersion().subscribe(async (data: any) => {
      const appData = await App.getInfo();
      this.isUpdateAvailable = data.versionCode > parseInt(appData.build);
    }, () => {

    })
  }

  openSessionDialog() {
    const dialog = this.dialog.open(RenewSessionDialogComponent, {
        data: { user: this.user }
      });
  
      dialog.afterClosed().subscribe( (data) => {
      })
  }

  onReject() {
    this.showSessionInfo = false;
  }

}
